module.exports = __webpack_public_path__ + "static/media/human_resource.a4f4aef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/human_resource.png
// module id = 502
// module chunks = 0